document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.collection-style-1-card');
  cards.forEach(function(card) {
    const activeColor = card.querySelector('.swatch-element.is-active');
    const activeColorDiv = card.querySelector('.collection-style-1-active-color');
    if (activeColor && activeColorDiv) {
      activeColorDiv.innerHTML = activeColor.dataset.value;
    }
  });
  const swatches = document.querySelectorAll('.collection-style-1-card .swatch-element');
  swatches.forEach(function(swatch) {
    swatch.addEventListener('mouseover', function() {
      const activeColorDiv = swatch.closest('.collection-style-1-card').querySelector('.collection-style-1-active-color');
      activeColorDiv.innerHTML = swatch.dataset.value;
    });
    swatch.addEventListener('mouseout', function() {
      const activeColorDiv = swatch.closest('.collection-style-1-card').querySelector('.collection-style-1-active-color');
      const activeColor = swatch.closest('.collection-style-1-card').querySelector('.swatch-element.is-active');
      activeColorDiv.innerHTML = activeColor.dataset.value;
    });
  });
});
